// n8n booth webhook helper.
//
// Required env vars (set in .env, not committed):
//   REACT_APP_N8N_BOOTH_WEBHOOK_URL
//   REACT_APP_N8N_BASIC_USER
//   REACT_APP_N8N_BASIC_PASS
//
// When any are missing the post is skipped, the payload is logged, and a
// simulated success resolves after 700ms — same dev-friendly fallback used by
// the EmailJS contact form.
export const N8N_BOOTH_WEBHOOK_URL = process.env.REACT_APP_N8N_BOOTH_WEBHOOK_URL;
export const N8N_BASIC_USER = process.env.REACT_APP_N8N_BASIC_USER;
export const N8N_BASIC_PASS = process.env.REACT_APP_N8N_BASIC_PASS;

function hasCreds() {
  return Boolean(N8N_BOOTH_WEBHOOK_URL && N8N_BASIC_USER && N8N_BASIC_PASS);
}

export async function postToBoothWebhook(payload) {
  if (!hasCreds()) {
    console.warn("[FlowWhite] n8n env vars missing. Booth submission logged locally only.");
    console.info("[FlowWhite] Booth submission:", payload);
    await new Promise((r) => setTimeout(r, 700));
    return { simulated: true };
  }

  const auth = btoa(`${N8N_BASIC_USER}:${N8N_BASIC_PASS}`);
  const res = await fetch(N8N_BOOTH_WEBHOOK_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Basic ${auth}`,
    },
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(`n8n webhook ${res.status}: ${text || res.statusText}`);
  }

  return { simulated: false };
}
